"use client";
import { ark } from "../factory.js";
import { useFieldContext } from "./use-field-context.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/field/field-helper-text.tsx
var FieldHelperText = forwardRef((props, ref) => {
	const mergedProps = mergeProps(useFieldContext()?.getHelperTextProps(), props);
	return /* @__PURE__ */ jsx(ark.span, {
		...mergedProps,
		ref
	});
});
FieldHelperText.displayName = "FieldHelperText";
//#endregion
export { FieldHelperText };
